











import { computed, defineComponent, reactive } from '@vue/composition-api';
import { useStore } from '@/components/composables/useStore';
import { Store } from 'vuex';
import { RootState } from '@/store/Store';

const Component = defineComponent({
  name: 'UpdateAlert',

  setup() {
    const store: Store<RootState> = useStore();

    const snack = computed({
      get: () => state.message !== '',
      set: (val: boolean) => {
        if (!val) dismissAlert();
      },
    });

    const state = reactive({
      color: computed(() => store.getters['uiModule/alertColor']),
      message: computed(() => store.getters['uiModule/alertMessage']),
    });

    function dismissAlert() {
      store.dispatch('uiModule/removeAlert');
    }

    return {
      snack,
      state,
      dismissAlert,
    };
  },
});

export default Component;
